export default __webpack_public_path__ + "static/img/vogue_scene_animated_0789.33ff1eb.webp";